// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"eQ","imgTextCardBox":"eQ","text-box":"eR","textBox":"eR","remark-val":"eS","remarkVal":"eS"};